import { calculation } from "@/method";
import Echarts from "echarts";
const color = ['#00C6BD', '#42585D', '#FF605F'];


export default ({
    data = [],
    last = [],
    area = [],
    arealast = [],
    interval = [],
    intervallast = [],
    areaLen = 1,
    intervalLen = 1,
}, day) => {

    return {
        data: compute({ data, day }),
        last: compute({ data: last, day }),
        area: compute({ data: area, day, length: areaLen }),
        arealast: compute({ data: arealast, day, length: areaLen }),
        interval: compute({ data: interval, day, length: intervalLen }),
        intervallast: compute({ data: intervallast, day, length: intervalLen }),
    }
}

function compute({ data, day, length }) {
    data.forEach((item, i) => {
        data[i].occ = calculation(item.sold, item.ava, 4);
        data[i].adr = calculation(item.roomrev, item.sold, 4);
        data[i].revpar = (data[i].occ * data[i].adr).toFixed(2);
        if ((day - 1) == i && day > 1) {
            data[i].occ_g = calculation(data[i].occ - data[i - 1].occ, data[i].occ, 4);
            data[i].adr_g = calculation(data[i].adr - data[i - 1].adr, data[i].adr, 4);
            data[i].revpar_g = calculation(data[i].revpar - data[i - 1].revpar, data[i].revpar, 4);
            data[i].roomrev_g = calculation(data[i].roomrev - data[i - 1].roomrev, data[i].roomrev, 4);
            data[i].fb_g = calculation(data[i].fb - data[i - 1].fb, data[i].fb, 4);
            data[i].total_g = calculation(data[i].total - data[i - 1].total, data[i].total, 4);
        }
        if (length && length >= 1) {
            data[i].roomrev = (data[i].roomrev / length).toFixed(2);
            data[i].fb = (data[i].fb / length).toFixed(2);
            data[i].total = (data[i].total / length).toFixed(2);
        }
    });
    return data
}

export const setKarte = ({
    month, day, dataY, title, type = ""
}, isOnResize) => {
    const myChart = Echarts.init(document.getElementById("chart"));
    myChart.resize();
    if (isOnResize) {
        return
    }
    const option = {
        color,
        title: {
            text: title,
            textStyle: {
                fontSize: 20
            }
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'cross' },
        },
        grid: {
            top: 120,
        },
        legend: {
            top: 30,
            data: dataY.map(x => x.name),
            textStyle: {
                fontSize: 18
            }
        },
        toolbox: {
            feature: {
                saveAsImage: {
                    show: true
                }
            }
        },
        xAxis: [
            {
                type: 'category',
                axisLabel: {
                    color: "black",
                    fontSize: 14,
                },
                data: new Array(Number(day)).fill(1).map((x, i) => `${month}/${i + 1}`)
            }
        ],
        yAxis: {
            type: 'value',
            name: '',
            axisLabel: {
                formatter: type == 'perncet' ? '{value}%' : '{value}'
            },

        },
        series: dataY.map((x, i) => {
            return {
                name: x.name,
                type: "line",
                smooth: true,
                data: type == "percent" ? x.data.map(x => (x * 100).toFixed(1)) : x.data,
            }
        }),
    }

    myChart.setOption(option);
}


// WEBPACK FOOTER //
// ./src/components/table/performanceAnalysis/analysisChart/1.2.1/compute.js